import { environment } from '@env';
import * as Rollbar from 'rollbar';

export function rollbarFactory(): Rollbar {
  return new Rollbar(environment.rollbarConfig);
}
